import { useSession } from "./useSession";

export const useCurrentUser = () => {
  const [session] = useSession();

  return session.state === "AUTHENTICATED" ? session.user : null;
};
